export default __webpack_public_path__ + "static/media/bni_q_logo.29c1501b.png";